module.exports = __webpack_public_path__ + "static/media/ro.b4f341b6.png";